module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAAA9klEQVRYCe2Xzw2CMBTGP413uwAJ557cQIbgrhvoCLiBbqD3DoEbeOJs0gVgAkyTR4JNCf9aS2K/pAcKvO8HIe99rOq6hk+tvbovAWAz9UYuZAIgo8OsSKN8Sp3R3wAXMgZwB7DXTj0BHIs0ejsBIGP1xIeeSx/0RgaB9AKMMJ4E0gnAhWRkfBpprOtGIOUgADI+09rONG9UAbiqpYN8AXAhdwByi8YmkKRIo1ezofcB5tAcVJu1N0InDAABIAAEgMUBlDQwXKkiDzMATSkVQC6WQSqqGbcnodLyAokBxE8kmwFiN5R2gPw+lhtA/PyY2Nafd0IAHweleWFH7csJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = 443
// module chunks = 114276838955818